import _ from 'lodash';
import { colors } from '@emjoy/shared/styles';

const getColor = _.memoize(path => (_.includes(path, '#') ? path : _.get(colors, path)));

export { getColor };
